import Tawk from "../_partials/Tawk";
import FacebookComment from "../_partials/FacebookComment";
import { GoogleAnalytics } from "../_partials/GoogleAnalytics";
import { Footer } from "../_partials/_footer/Footer";
import Cookie from "../_partials/Cookie";
import Navbar from "../_partials/_navbar/Navbar";
import { usePathname } from "next/navigation";
import TopLoader from "../_partials/TopLoader";
import { Toaster } from "react-hot-toast";
import HandleChildren from "../_partials/HandleChildren";
import PushNotificationComponent from "../_partials/PushNotification";
import { useMarqueeData } from "../_hooks/useMarqueeData";

function TickerContent() {
    const marqueeContent = useMarqueeData();
    return (
        <span style={{ display: "inline-flex", alignItems: "center", gap: "6px", paddingRight: "120px" }}>
           
            <span style={{ color: "#e2e8f0", fontSize: "13px" }}>
                {marqueeContent}
            </span>
        </span>
    );
}

function SecurityTicker() {
    return (
        <div style={{ position: "sticky", top: 0, zIndex: 1050, background: "#1e293b", overflow: "hidden", padding: "3px 0" }}>
            <div
                style={{
                    display: "inline-flex",
                    whiteSpace: "nowrap",
                    animation: "securityTicker 55s linear infinite",
                }}
                onMouseEnter={e => e.currentTarget.style.animationPlayState = "paused"}
                onMouseLeave={e => e.currentTarget.style.animationPlayState = "running"}
            >
                {/* Two identical copies — animation moves -50% so the second copy
                    always immediately follows the first with no blank gap */}
                <TickerContent />
                <TickerContent />
            </div>
            <style>{`
                @keyframes securityTicker {
                    0%   { transform: translateX(0); }
                    100% { transform: translateX(-50%); }
                }
            `}</style>
        </div>
    );
}

export default function HandleFrontendChildren({ children }) {

    const pathname = usePathname();

    if (
        pathname.startsWith("/login") ||
        pathname.startsWith("/verify-email") ||
        pathname.startsWith("/password-reset-request") ||
        pathname.startsWith("/reset-request-verify") ||
        pathname.startsWith("/password-reset") ||
        pathname.startsWith("/authorization") ||
        pathname.startsWith("/register") ||
        pathname.startsWith("/maintenance-mode")
    ) {
        return (
            <HandleChildren>
                <TopLoader />

                <Toaster position="top-right" reverseOrder={false} />
                <GoogleAnalytics />
                {children}
            </HandleChildren>
        );
    }

    return (
        <>
            <PushNotificationComponent />

            <HandleChildren>
                <TopLoader />
                <Toaster position="top-right" reverseOrder={false} />
                <SecurityTicker />
                <Navbar />
                <Tawk />
                <FacebookComment />
                <GoogleAnalytics />
                {children}
                <Footer />
                <Cookie />
            </HandleChildren>
        </>
    );
}
